export default __webpack_public_path__ + "static/media/master.20b68bc9.png";